import * as THREE from 'three'
import { gsap } from 'gsap'

export function createStarBackground(scene, camera, onDiscClick = null, config) {
    let disc = null
    let isFadingOut = false
    if (!scene || !camera) return null

    const starsRef = new THREE.Group()

    const discGroup = new THREE.Group()
    starsRef.add(discGroup)

    const starCount = 5000
    const starSize = 10.5
    const starDistanceMax = 200
    const galaxyRadius = 10

    const canvas = document.createElement('canvas')
    canvas.width = 32
    canvas.height = 32

    const context = canvas.getContext('2d')
    const gradient = context.createRadialGradient(
        canvas.width / 2,
        canvas.height / 2,
        0,
        canvas.width / 2,
        canvas.height / 2,
        canvas.width / 2
    )

    gradient.addColorStop(0, 'rgba(255, 255, 255, 1)')
    gradient.addColorStop(0.4, 'rgba(255, 240, 255, 1)')
    gradient.addColorStop(1, 'rgba(0, 0, 0, 0)')

    context.fillStyle = gradient
    context.fillRect(0, 0, canvas.width, canvas.height)

    const starTexture = new THREE.CanvasTexture(canvas)
    starTexture.needsUpdate = true

    const positions = new Float32Array(starCount * 3)
    for (let i = 0; i < starCount; i++) {
        const i3 = i * 3

        const x = (Math.random() - 0.5) * galaxyRadius * starDistanceMax
        const y = (Math.random() - 0.5) * galaxyRadius * starDistanceMax
        const z = (Math.random() - 0.5) * galaxyRadius * starDistanceMax

        const distance = Math.sqrt(x * x + y * y + z * z)

        if (distance < 500) {
            const scale = 5 / distance
            positions[i3] = x * scale
            positions[i3 + 1] = y * scale
            positions[i3 + 2] = z * scale
        } else {
            positions[i3] = x
            positions[i3 + 1] = y
            positions[i3 + 2] = z
        }
    }

    const sizes = new Float32Array(starCount)
    for (let i = 0; i < starCount; i++) {
        sizes[i] = Math.random() * starSize
    }

    const pointsMaterial = new THREE.PointsMaterial({
        size: starSize,
        map: starTexture,
        transparent: true,
        blending: THREE.AdditiveBlending,
        depthWrite: false,
        sizeAttenuation: true,
        alphaTest: 0.001,
        fog: false
    })

    const starsGeometry = new THREE.BufferGeometry()
    starsGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
    starsGeometry.setAttribute('size', new THREE.BufferAttribute(sizes, 1))

    const starsMesh = new THREE.Points(starsGeometry, pointsMaterial)
    starsRef.add(starsMesh)

    scene.add(starsRef)

    const textureLoader = new THREE.TextureLoader()
    const discTexture = textureLoader.load('/image.png')

    const discGeometry = new THREE.CircleGeometry(20, 32)
    const discMaterial = new THREE.MeshBasicMaterial({
        map: discTexture,
        transparent: true,
        side: THREE.DoubleSide,
        opacity: 1.0,
        alphaTest: 0.01,
        blending: THREE.NormalBlending
    })

    disc = new THREE.Mesh(discGeometry, discMaterial)
    discGroup.add(disc)

    disc.position.set(200, 80, -80)
    disc.scale.set(3, 3, 3)
    disc.lookAt(camera.position)
    disc.userData.isInteractive = true
    disc.userData.message = ""

    config.fetchWelcomeMessage()
        .then(data => {
            if (data.success && data.data) {
                disc.userData.message = data.data.message
            }
        })
        .catch((e) => {
            console.log('Error fetching welcome message', e);

            disc.userData.message = "Welcome to the interactive 3D globe tracking token locations in time."
        })

    const animate = () => {
        if (starsRef) {
            starsRef.rotation.y += 0.0002
            starsRef.rotation.x += 0.0001
        }

        if (disc && camera) {
            disc.lookAt(camera.position)

            const distanceToCenter = camera.position.length()

            // if (!isFadingOut) {
            //     disc.visible = distanceToCenter > 250
            // }
        }

        requestAnimationFrame(animate)
    }

    animate()

    if (scene && camera) {
        const raycaster = new THREE.Raycaster()
        const mouse = new THREE.Vector2()

        const onMouseMove = (event) => {
            mouse.x = (event.clientX / window.innerWidth) * 2 - 1
            mouse.y = -(event.clientY / window.innerHeight) * 2 + 1
            raycaster.setFromCamera(mouse, camera)

            const intersects = raycaster.intersectObject(disc)

            if (intersects.length > 0 && disc.visible) {
                document.body.style.cursor = 'pointer'
            } else {
                document.body.style.cursor = 'default'
            }
        }

        const onClick = (event) => {
            mouse.x = (event.clientX / window.innerWidth) * 2 - 1
            mouse.y = -(event.clientY / window.innerHeight) * 2 + 1
            raycaster.setFromCamera(mouse, camera)


            const intersects = raycaster.intersectObject(disc)

            if (intersects.length > 0 && disc.visible) {
                if (onDiscClick) {
                    onDiscClick(disc.userData.message)
                }
            }
        }

        window.addEventListener('mousemove', onMouseMove)
        window.addEventListener('click', onClick)
    }

    starsRef.fadeOutDisc = () => {
        if (disc && disc.visible) {

            // Create a uniform variable to control opacity
            const opacityValue = { value: 1.0 }

            // Update the disc material on each frame

            if (!isFadingOut) {
                // Animate the uniform variable
                gsap.to(opacityValue, {
                    value: 0,
                    duration: 1.5,
                    onUpdate: () => {
                        updateOpacity(disc, opacityValue)
                    },
                    onComplete: () => {
                        disc.visible = false
                        isFadingOut = false
                    }
                })
            }
            isFadingOut = true


        }
    }
    const updateOpacity = (disc, opacityValue) => {
        if (disc && disc.material) {
            disc.material.opacity = opacityValue.value
            disc.material.needsUpdate = true
        }
    }
    
    starsRef.fadeInDisc = () => {

        if (disc && !disc.visible) {
            const opacityValue = { value: 0.0 }
            if (!isFadingOut) {
                disc.visible = true

                gsap.to(opacityValue, {
                    value: 1,
                    duration: 1.5,
                    onUpdate: () => {
                        updateOpacity(disc, opacityValue)
                    },
                    onComplete: () => {
                        isFadingOut = false
                    }
                })
            }
            isFadingOut = true
        }
    }

    return starsRef
}
